import React from "react";

const Index = () => {
  return (
    <>
      <div>
        <div className="animate-pulse bg-slate-100 rounded-xl !h-[200px] sm:!h-[250px] md:!h-[250px] lg:!h-[200px] xl:!h-[300px]"></div>
        <div className="block py-4">
          <div className="animate-pulse bg-slate-100 h-6 w-40 rounded-md mb-2"></div>
          <div className="flex space-x-4 items-center">
            <div className="animate-pulse bg-slate-100 h-6 w-14 rounded-md"></div>
            <div className="animate-pulse h-[6px] w-[6px] mx-2 rounded-full bg-slate-100"></div>
            <div className="animate-pulse bg-slate-100 h-6 w-14 rounded-md"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
